import React, { useState, useEffect } from 'react';
import CreateUrl from './components/CreateUrl';
import UrlList from './components/UrlList';
import Analytics from './components/Analytics';
import Dashboard from './components/Dashboard';
import './index.css';

function App() {
  const [activeView, setActiveView] = useState('create');
  const [analyticsShortCode, setAnalyticsShortCode] = useState('');

  useEffect(() => {
    // Handle URL hash for navigation
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1);
      
      if (hash.startsWith('analytics/')) {
        const shortCode = hash.split('/')[1];
        setAnalyticsShortCode(shortCode);
        setActiveView('analytics');
      } else if (hash) {
        setActiveView(hash);
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const handleNavClick = (view) => {
    setActiveView(view);
    window.location.hash = view;
  };

  return (
    <div>
      <header className="header">
        <div className="container">
          <h1>🔗 QR URL Shortener</h1>
          <p>Create short URLs with QR codes and track analytics</p>
          
          <nav className="nav">
            <button
              className={activeView === 'create' ? 'active' : ''}
              onClick={() => handleNavClick('create')}
            >
              Create URL
            </button>
            <button
              className={activeView === 'list' ? 'active' : ''}
              onClick={() => handleNavClick('list')}
            >
              My URLs
            </button>
            <button
              className={activeView === 'dashboard' ? 'active' : ''}
              onClick={() => handleNavClick('dashboard')}
            >
              Dashboard
            </button>
          </nav>
        </div>
      </header>

      <main className="container">
        {activeView === 'create' && <CreateUrl />}
        {activeView === 'list' && <UrlList />}
        {activeView === 'dashboard' && <Dashboard />}
        {activeView === 'analytics' && <Analytics shortCode={analyticsShortCode} />}
      </main>

      <footer style={{ textAlign: 'center', padding: '40px 20px', color: '#7f8c8d' }}>
        <p>Self-hosted QR URL Shortener with Analytics</p>
      </footer>
    </div>
  );
}

export default App;
